// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"OQ-z","categoryName":"PQ-z","categoryNameSearchHeader":"QQ-z","categoryContent":"RQ-z","bottomAligned":"SQ-z","image":"TQ-z","imageNoBackground":"UQ-z"};